/***********************************
** 折叠面板
** 格式
<div class="collapse-loop">
    <div class="item active">
        <div class="item-hd">折叠面板标题</div>
        <div class="item-md">折叠面板内容</div>
    </div>
    <div class="item">
        <div class="item-hd">折叠面板标题</div>
        <div class="item-md">折叠面板内容</div>
    </div>
    <div class="item">
        <div class="item-hd">折叠面板标题</div>
        <div class="item-md">折叠面板内容</div>
    </div>
</div>
************************************/
$(function () {
    // 折叠面板
    $(".collapse-loop").on("click", ".item-hd", function () {
        $(this).siblings(".item-md").slideToggle().parents(".item").toggleClass("active").siblings(".item").removeClass("active").children(".item-md").slideUp();
    });
    $(".collapse-loop").on("click", ".close", function () {
        $(this).parents(".item-md").slideUp().parents(".item").removeClass("active");
    })
});